import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    fill="none"
    stroke="rgb(141,141,141)"
    strokeWidth={3}
    viewBox="0 0 64 64"
    {...props}
  >
    <path d="M53.72 36.61a21.91 21.91 0 1 1-3.35-16.51" />
    <path d="m51.72 7.85-.87 12.93-12.93-.88" />
    <path d="M53.72 36.61a21.91 21.91 0 1 1-3.35-16.51" />
    <path d="m51.72 7.85-.87 12.93-12.93-.88" />
  </svg>
)
export default SvgComponent
